import { useCallback } from 'react';
import { useWorkflowExtras } from '@sluitstraat/core';

export const useSharedFamilyComposition = () => {
  const { sharedData, saveSharedData } = useWorkflowExtras();

  const familyComposition: string = (sharedData?.familyComposition as string) || '';

  const setFamilyComposition = useCallback(
    (value: string) => {
      saveSharedData({ familyComposition: value });
    },
    [saveSharedData],
  );

  return { familyComposition, setFamilyComposition };
};
